import type { NextPage } from 'next'
import React from 'react'
import homeStyles from '../styles/Home.module.css'
import styles from '../styles/Faq.module.css'
import Common from './common'

interface FaqProps {}

const Faq: NextPage<FaqProps> = () => {
  return (
    <Common>
      <div className={styles.faq}>
        <p className={styles.question}>Why can you only reroll 3 times per day?</p>
        <p className={styles.answer}>
          To reduce cognitive load, and &ldquo;doom&rdquo; refreshing. This app is meant to help
          with reducing the number of choices that you already make in your busy Perth CBD life.
        </p>
        <p className={styles.question}>Can you add feature X?</p>
        <p className={styles.answer}>
          Short answer is probably no, as extra features will just increase bloat and complexity,
          something this app is trying to help you avoid.
        </p>
        <p className={styles.question}>Why does this app exist?</p>
        <p className={styles.answer}>
          My office recently moved closer to the Perth CBD. We were inundated with too many lunch
          choices and I thought it would be fun to make this extremely specific app.
        </p>
        <p className={styles.answer}>
          See:
          <ul>
            <li>
              <a href="https://en.wikipedia.org/wiki/Overchoice">Overchoice</a>
            </li>
            <li>
              <a href="https://en.wikipedia.org/wiki/Analysis_paralysis">Analysis paralysis</a>
            </li>
            <li>
              <a href="https://en.wikipedia.org/wiki/The_Paradox_of_Choice">
                The Paradox of Choice
              </a>
            </li>
            <li>
              <a href="https://en.wikipedia.org/wiki/Tyranny_of_small_decisions">
                Tyranny of small decisions
              </a>
            </li>
            <li>
              <a href="https://en.wikipedia.org/wiki/Paradox_of_plenty">Paradox of Plenty</a>
            </li>
            <li>
              <a href="https://en.wikipedia.org/wiki/Buridan%27s_ass">Buridan&apos;s ass</a>
            </li>
          </ul>
        </p>
        <p className={styles.question}>What&apos;s the Tech stack?</p>
        <p className={styles.answer}>
          <ul>
            <li>NextJS/React/Typescript</li>
            <li>NodeJS/Typescript</li>
            <li>
              MongoDB (but there are no DB calls in production, everything is served statically)
            </li>
          </ul>
        </p>
      </div>
    </Common>
  )
}

export default Faq
